import type { RowMarker } from "../../../../src/lib/audio";

export type GoToMarker = {
  step: number;
  label: string;
  color: number;
};

/** Collect labeled row markers from a pattern's marker map. */
export function markersFromMap(
  markers: Record<string, RowMarker> | undefined,
): GoToMarker[] {
  if (!markers) {
    return [];
  }
  const out: GoToMarker[] = [];
  for (const [key, value] of Object.entries(markers)) {
    const step = Number(key);
    const label = value?.label?.trim();
    if (!Number.isInteger(step) || step < 0 || !label) {
      continue;
    }
    out.push({ step, label, color: value.color ?? 0 });
  }
  return out;
}
